import { render, staticRenderFns } from "./boxOnlineUser.vue?vue&type=template&id=7b13883b&scoped=true&"
import script from "./boxOnlineUser.vue?vue&type=script&lang=js&"
export * from "./boxOnlineUser.vue?vue&type=script&lang=js&"
import style0 from "./boxOnlineUser.vue?vue&type=style&index=0&id=7b13883b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13883b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b13883b')) {
      api.createRecord('7b13883b', component.options)
    } else {
      api.reload('7b13883b', component.options)
    }
    module.hot.accept("./boxOnlineUser.vue?vue&type=template&id=7b13883b&scoped=true&", function () {
      api.rerender('7b13883b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/boxOnlineUser.vue"
export default component.exports